$(document).ready(function () {
  var arallcountries = [
    { code: "AL", name: "Albania" },
    { code: "AT", name: "Austria" },
    { code: "AU", name: "Australia" },
    { code: "BY", name: "Belarus" },
    { code: "BE", name: "Belgium" },
    { code: "BA", name: "Bosnia and Herzegovina" },
    { code: "BG", name: "Bulgaria" },
    { code: "CA", name: "Canada" },
    { code: "CN", name: "China" },
    { code: "HR", name: "Croatia" },
    { code: "CY", name: "Cyprus" },
    { code: "CZ", name: "Czech" },
    { code: "DK", name: "Denmark" },
    { code: "EE", name: "Estonia" },
    { code: "FO", name: "Faroe Islands" },
    { code: "FI", name: "Finland" },
    { code: "FR", name: "France" },
    { code: "DE", name: "Germany" },
    { code: "GR", name: "Greece" },
    { code: "GL", name: "Greenland" },
    { code: "HK", name: "Hong Kong" },
    { code: "HU", name: "Hungary" },
    { code: "IS", name: "Iceland" },
    { code: "IE", name: "Ireland" },
    { code: "IT", name: "Italy" },
    { code: "JP", name: "Japan" },
    { code: "LV", name: "Latvia" },
    { code: "LI", name: "Liechtenstein" },
    { code: "LT", name: "Lithuania" },
    { code: "LU", name: "Luxembourg" },
    { code: "MO", name: "Macao" },
    { code: "MY", name: "Malaysia" },
    { code: "MC", name: "Monaco" },
    { code: "MT", name: "Malta" },
    { code: "NL", name: "Netherlands" },
    { code: "NO", name: "Norway" },
    { code: "PL", name: "Poland" },
    { code: "PT", name: "Portugal" },
    { code: "QA", name: "Qatar" },
    { code: "RO", name: "Romania" },
    { code: "SA", name: "Saudi Arabia" },
    { code: "RS", name: "Serbia" },
    { code: "SG", name: "Singapore" },
    { code: "SK", name: "Slovakia" },
    { code: "SI", name: "Slovenia" },
    { code: "ES", name: "Spain" },
    { code: "SE", name: "Sweden" },
    { code: "CH", name: "Switzerland" },
    { code: "TW", name: "Taiwan" },
    { code: "TH", name: "Thailand" },
    { code: "TR", name: "Turkey" },
    { code: "UA", name: "Ukraine" },
    { code: "UAE", name: "United Arab Emirates" },
    { code: "UK", name: "United Kingdom" },
    { code: "US", name: "United States" },
    { code: "VA", name: "Vatican City" },
    { code: "VN", name: "Vietnam" },
    { code: "REST", name: "Rest Of The World" },
  ];

  var getCookie = function (name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) {
      return parts.pop().split(";").shift();
    }
  };
  function getCountryName(code) {
    const country = arallcountries.find((c) => c.code === code.toUpperCase());
    return country ? country.name : "Rest Of The World";
  }

  var country = getCookie("country-origin");
  var countryname = getCountryName(country);
  // console.log(countryname);

  if (
    $('.progress_bar_values[data-country="' + countryname + '"]').length == 0
  ) {
    countryname = "Rest Of The World";
  }

  $('.progress_bar_values[data-country="' + countryname + '"]').addClass(
    "current-country"
  );

  $('.upsell-main-container[data-country="' + countryname + '"]').show();
  $('.upsell-main-container[data-country="' + countryname + '"]').addClass(
    "upsell-active"
  );
  class CartWatcher {
    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
      });
    }

    async fetchCart() {
      const response = await fetch("/cart.js");
      return response.json();
    }

    storeCart(cart) {
      localStorage.setItem("cart", JSON.stringify(cart));
    }

    storedCart() {
      return JSON.parse(localStorage.getItem("cart")) || { items: [] };
    }

    findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) =>
        l.filter((li) => !r.some((ri) => li.key == ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
      };

      oldCart.items.forEach((oi) => {
        const ni = newCart.items.find(
          (i) => i.key == oi.key && i.quantity != oi.quantity
        );
        if (!ni) return;
        let quantity = ni.quantity - oi.quantity;
        let item = { ...ni };
        item.quantity = Math.abs(quantity);
        quantity > 0 ? result.added.push(item) : result.removed.push(item);
      });

      return result;
    }

    async emitCartChanges() {
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();
      const changes = this.findCartChanges(oldCart, newCart);
      if(areJSONsEqual(newCart, oldCart) == false){
         const event = new CustomEvent("cart_changed", { detail: newCart });
         window.dispatchEvent(event);
      }
     

      this.storeCart(newCart);
    }

    observeCartChanges() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
            entry.initiatorType
          );
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }
  }

  function areJSONsEqual(json1, json2) {
    return JSON.stringify(json1) === JSON.stringify(json2);
  }

  const myCartWatcher = new CartWatcher();
  myCartWatcher.init();
  window.addEventListener("cart_changed", function (e) {
       
    checkcart(e.detail);

    $('#upsell-main-container[data-country="' + countryname + '"]').load(
      location.href +
        ' #upsell-main-container[data-country="' +
        countryname +
        '"] > *',
      "",
      function () {
        var country = countryname;
        const getEstimatedDate = new CustomEvent("fetchUpsellItemsDate", {
          detail: { country: country },
        });
        window.dispatchEvent(getEstimatedDate);
        $('.upsell-main-container[data-country="' + countryname + '"]').show();
        $('.upsell-main-container[data-country="' + countryname + '"]').addClass(
          "upsell-active"
        );
      }
    );
  });

  var symbol = $("body").data("currency_sym");

  var currentelem = $(".progress_bar_values.current-country");
  var tierscount = Number(currentelem.attr("data-tiers"));
  var threshold1 = Number(currentelem.attr("data-threshold1"));
  var threshold1text = currentelem.attr("data-threshold1text");
  var threshold1code = currentelem.attr("data-threshold1code");
  var threshold2 = Number(currentelem.attr("data-threshold2"));
  var threshold2text = currentelem.attr("data-threshold2text");
  var threshold2code = currentelem.attr("data-threshold2code");
  var threshold3 = Number(currentelem.attr("data-threshold3"));
  var threshold3text = currentelem.attr("data-threshold3text");
  var threshold3code = currentelem.attr("data-threshold3code");
  var completedtext = currentelem.attr("data-completedtext");
  var beforetier1 = currentelem.attr("data-beforetier1");
  var beforetier2 = currentelem.attr("data-beforetier2");
  var beforetier3 = currentelem.attr("data-beforetier3");

  if (tierscount == 1) {
    $(".progress-bar-container")
      .append(`<div class="threshold threshold-1" style="left: 50%;">
        <span class="price">${Shopify.formatMoney(
          threshold1,
          symbol + "{{amount}}"
        )} </span>
         <span class="main"> </span>
        <span class="discount">${threshold1text}</span>
      </div>`);
  }

  if (tierscount == 2) {
    $(".progress-bar-container")
      .append(`<div class="threshold threshold-1" style="left: 25%;">
        <span class="price">${Shopify.formatMoney(
          threshold1,
          symbol + "{{amount}}"
        )} </span>
         <span class="main"> </span>
        <span class="discount">${threshold1text}</span>
      </div>`);
    $(".progress-bar-container")
      .append(`<div class="threshold threshold-2" style="left: 75%;">
        <span class="price">${Shopify.formatMoney(
          threshold2,
          symbol + "{{amount}}"
        )} </span>
         <span class="main"> </span>
        <span class="discount">${threshold2text}</span>
      </div>`);
  }
  if (tierscount == 3) {
    $(".progress-bar-container")
      .append(`<div class="threshold threshold-1" style="left: 25%;">
        <span class="price">${Shopify.formatMoney(
          threshold1,
          symbol + "{{amount}}"
        )} </span>
         <span class="main"> </span>
        <span class="discount">${threshold1text}</span>
      </div>`);
    $(".progress-bar-container")
      .append(`<div class="threshold threshold-2" style="left: 50%;">
        <span class="price">${Shopify.formatMoney(
          threshold2,
          symbol + "{{amount}}"
        )} </span>
         <span class="main"> </span>
        <span class="discount">${threshold2text}</span>
      </div>`);
    $(".progress-bar-container")
      .append(`<div class="threshold threshold-2" style="left: 75%;">
        <span class="price">${Shopify.formatMoney(
          threshold3,
          symbol + "{{amount}}"
        )} </span>
         <span class="main"> </span>
        <span class="discount">${threshold3text}</span>
      </div>`);
  }

  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cartdata) {
      checkcart(cartdata);
    },
  });

  function checkcart(cartdata) {
    //$('.cart-loader-full').show();

    var showpr = true;
    if (tierscount == 1) {
      if (cartdata.original_total_price < threshold1) {
        var amountrem = threshold1 - cartdata.original_total_price;
        $(".cart-discount-progress .text-code").html(
          beforetier1.replace("{{amount_left}}", amountrem)
        );
        clearDiscount();
        $(".progress-bar").find("#progress").css("width", "40%");
      } else {
        $(".cart-discount-progress .text-code").html(completedtext);
        applyDiscountnew(threshold1code);
        $(".progress-bar").find("#progress").css("width", "100%");
      }
    }
    if (tierscount == 2) {
      if (cartdata.original_total_price < threshold1) {
        var amountrem = threshold1 - cartdata.original_total_price;
        var amountremtext = Shopify.formatMoney(
          amountrem,
          symbol + "{{amount}}"
        );
        $(".cart-discount-progress .text-code").html(
          beforetier1.replace("{{amount_left}}", amountremtext)
        );

        clearDiscount();
        $(".progress-bar").find("#progress").css("width", "23%");
      } else if (
        cartdata.original_total_price >= threshold1 &&
        cartdata.original_total_price <= threshold2
      ) {
        var amountrem = threshold2 - cartdata.original_total_price;
        var amountremtext = Shopify.formatMoney(
          amountrem,
          symbol + "{{amount}}"
        );
        $(".cart-discount-progress .text-code").html(
          beforetier2.replace("{{amount_left}}", amountremtext)
        );
        applyDiscountnew(threshold1code);
        $(".progress-bar").find("#progress").css("width", "45%");
      } else {
        applyDiscountnew(threshold2code);
        $(".cart-discount-progress .text-code").html(completedtext);
        $(".progress-bar").find("#progress").css("width", "100%");
      }
    }
    if (tierscount == 3) {
      if (cartdata.original_total_price < threshold1) {
        var amountrem = threshold1 - cartdata.original_total_price;
        var amountremtext = Shopify.formatMoney(
          amountrem,
          symbol + "{{amount}}"
        );
        $(".cart-discount-progress .text-code").html(
          beforetier1.replace("{{amount_left}}", amountremtext)
        );
        clearDiscount();
        $(".progress-bar").find("#progress").css("width", "23%");
      } else if (
        cartdata.original_total_price >= threshold1 &&
        cartdata.original_total_price <= threshold2
      ) {
        var amountrem = threshold2 - cartdata.original_total_price;
        var amountremtext = Shopify.formatMoney(
          amountrem,
          symbol + "{{amount}}"
        );
        $(".cart-discount-progress .text-code").html(
          beforetier2.replace("{{amount_left}}", amountremtext)
        );
        applyDiscountnew(threshold1code);
        $(".progress-bar").find("#progress").css("width", "45%");
      } else if (
        cartdata.original_total_price >= threshold2 &&
        cartdata.original_total_price <= threshold3
      ) {
        var amountrem = threshold3 - cartdata.original_total_price;
        var amountremtext = Shopify.formatMoney(
          amountrem,
          symbol + "{{amount}}"
        );
        $(".cart-discount-progress .text-code").html(
          beforetier3.replace("{{amount_left}}", amountremtext)
        );
        applyDiscountnew(threshold3code);
        $(".progress-bar").find("#progress").css("width", "67%");
      } else {
        $(".cart-discount-progress .text-code").html(completedtext);
        applyDiscountnew(threshold3code);
        $(".progress-bar").find("#progress").css("width", "100%");
      }
    }
    if (cartdata.original_total_price <= 0) {
      $(".cart-discount-progress").hide();
    } else {
      $(".cart-discount-progress").show();
    }
  }

  function applyDiscountnew(code) {
    fetch("/discount/" + code)
      .then((response) => {
        const startEvent = new Event("cart:build");
        document.dispatchEvent(startEvent);

        $(".cart-loader-full").hide();
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
  function clearDiscount() {
    clearLocalStorage();
    fetch("/discount/CLEAR")
      .then((response) => {
        const startEvent = new Event("cart:build");
        document.dispatchEvent(startEvent);

        $(".cart-loader-full").hide();
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
  function clearLocalStorage() {
    localStorage.removeItem("discountCode");
  }
});
